import { useRouteError, useNavigate } from "react-router-dom";
import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Box,
  Center,
  Flex,
} from "@mantine/core";
import { FileQuestion, Home, ArrowLeft } from "lucide-react";
import MainNavigation from "../components/navigation/MainNavigation";

function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = "An error occurred!";
  let message = "Something went wrong!";

  if (error.status === 500) {
    message = error.data.message;
  }

  if (error.status === 404) {
    title = "404 - Page Not Found";
    message =
      "The page you are looking for might have been moved, deleted, or never existed in the first place.";
  }

  return (
    <Flex direction="column" style={{ minHeight: "100vh" }}>
      <MainNavigation />

      <Center component="main" style={{ flex: 1, padding: "20px" }}>
        <Container size="md">
          <Box ta="center">
            <Box mb="xl">
              <FileQuestion size={120} color="#dee2e6" strokeWidth={1.5} />
            </Box>

            <Title
              style={{
                fontSize: "clamp(24px, 5vw, 34px)",
                fontWeight: 900,
                letterSpacing: "-1px",
              }}
              mb="md"
            >
              {title}
            </Title>

            <Text c="dimmed" size="lg" maw={500} mx="auto" mb="xl">
              {message}
            </Text>

            <Group justify="center" gap="md">
              <Button
                variant="outline"
                color="gray"
                size="md"
                leftSection={<ArrowLeft size={18} />}
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>

              <Button
                size="md"
                style={{ backgroundColor: "#1971c2" }}
                leftSection={<Home size={18} />}
                onClick={() => navigate("/")}
              >
                Take me Home
              </Button>
            </Group>
          </Box>
        </Container>
      </Center>
    </Flex>
  );
}

export default ErrorPage;
